module.exports = "/images/my.svg?6b2f0ae9428641eb0669f8a4eede3dda";